import { c as _c } from "react/compiler-runtime";
import { DARK_THEME } from "../../../../styles";
import { fillVariants } from "../../../../styles/utils/fill";
import { classNames } from "../../../../utils";
export function Verified(t0) {
  const $ = _c(23);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      size: t1,
      fill: t2,
      fillAttribute: t3,
      innerFill: t4,
      innerFillAttribute: t5,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "blue-3" : t2;
  const fillAttribute = t3 === undefined ? DARK_THEME.blue3 : t3;
  const innerFill = t4 === undefined ? "white" : t4;
  const innerFillAttribute = t5 === undefined ? "white" : t5;
  let t6;
  if ($[8] !== className || $[9] !== fill) {
    t6 = classNames("shrink-0", fillVariants({
      fill
    }), className);
    $[8] = className;
    $[9] = fill;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm94-278 226-226-56-58-170 170-86-84-56 56 142 142Z" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== innerFill) {
    t8 = fillVariants({
      fill: innerFill
    });
    $[12] = innerFill;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== innerFillAttribute || $[15] !== t8) {
    t9 = <path className={t8} d="M438-338 L664-564 L608-622 L438-452 L352-538 L296-482 L438-338 Z" fill={innerFillAttribute} />;
    $[14] = innerFillAttribute;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== fillAttribute || $[18] !== rest || $[19] !== size || $[20] !== t6 || $[21] !== t9) {
    t10 = <svg aria-label="Verified" className={t6} fill={fillAttribute} height={size} role="img" viewBox="0 -960 960 960" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t7}{t9}</svg>;
    $[17] = fillAttribute;
    $[18] = rest;
    $[19] = size;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}